import React from 'react';
import cn from '@/utils/cn';
import { TABLE_ROW_WITH_BORDER_CLASS } from '../utils';

type TableDataProps = {
  children: React.ReactNode;
};

const TableData = ({ children } : TableDataProps) => (
  <td className={cn(TABLE_ROW_WITH_BORDER_CLASS)}>
    {children}
  </td>
);

export default TableData;
